//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MainSection from './components/mainSection';
import ChoiceDialog from './components/choiceDialog';
import DetailProductDialog from './components/detailProductDialog';
import BasketDialog from './components/basketDialog';
import HeaderSale from './components/header/-header.vue';
import SaleFilter from './components/-filter.vue';
import SaleCardsSection from './components/cards/-saleCardsSection.vue';
import { htmlToText } from 'html-to-text';
import SaleForm from './components/form';
import SalePanel from './components/salePanel';
import FloatingBasket from './components/floatingBasket';
import { mapGetters } from 'vuex';

// TODO: всю логику с корзиной распутать и перенести в стор
import basketMixin from '../../../mixins/basket';
import {
  getAdditionalCoursesFromBasket,
  getCoursesWithAllFields,
} from '../utils';
import differenceBy from 'lodash/differenceBy';
import handleError from '@/utils/handleError';

export default {
  components: {
    SaleFilter,
    MainSection,
    ChoiceDialog,
    DetailProductDialog,
    BasketDialog,
    SaleCardsSection,
    HeaderSale,
    SaleForm,
    SalePanel,
    FloatingBasket,
  },
  mixins: [basketMixin],
  middleware: ['nomenclatureTypes', 'setSaleDirections'],
  data() {
    return {
      namespace: 'newSale',

      salePanelTop: null,
      salePanelBottom: null,
      currentWidth: null,
      mobileBreakpoint: 600,

      // TODO: всю логику с корзиной распутать и перенести в стор
      giftBasketItems: [],
      giftBasketItemsIds: [],
      promocodeItems: [],
      promocodeItemsIds: [],
      requestCompanyCatalog: [],
    };
  },
  head() {
    const sale = this.$store.state.sale.sale;
    return {
      bodyAttrs: {
        class: 'sale-body',
      },
      title: this.convertedTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.convertedDescription,
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: `https://${this.$app.config.current.domain}${this.$route.path}`,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.convertedTitle,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.convertedDescription,
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: `https://${
            this.$store?.state?.host
          }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/ebac-logo.png`)}`,
        },
      ],
      script: [
        this.grsfCampaignId &&
          this.isBr && {
            type: 'text/javascript',
            innerHTML: `
              (function(g,r,s,f){g.grsfSettings={campaignId:"${this.grsfCampaignId}",version:"2.0.0"};s=r.getElementsByTagName("head")[0];f=r.createElement("script");f.async=1;f.src="https://app.growsurf.com/growsurf.js"+"?v="+g.grsfSettings.version;f.setAttribute("grsf-campaign", g.grsfSettings.campaignId);!g.grsfInit?s.appendChild(f):"";})(window,document);
            `,
          },
      ],
    };
  },
  computed: {
    ...mapGetters('sale', [
      'basketType',
      'isSaleWithoutPrice',
      'isCompanyCatalog',
      'isPartner',
    ]),
    isMx() {
      return this.$nuxt.$config.COUNTRY === 'mx';
    },
    isBr() {
      return this.$nuxt.$config.COUNTRY === 'br';
    },
    convertedTitle() {
      let name = this.$store.state?.sale?.sale?.name || '';
      name = htmlToText(name) || '';
      name = name.replace(/\u00a0/g, ' ');

      const append = this.$t('meta.sale.title');

      return `${name} ${append}`;
    },
    convertedDescription() {
      return (
        htmlToText(this.$store.state?.sale?.sale?.description) || ''
      ).replace(/\u00a0/g, ' ');
    },
    isSaleReferral() {
      return this.$store.getters['sale/isSaleReferral'](this);
    },
    grsfCampaignId() {
      return this.$store.getters['sale/grsfCampaignId'](this);
    },
  },
  watch: {
    async basket() {
      this.giftBasketItemsIds = await getAdditionalCoursesFromBasket(
        this.basket,
        this.$app.config.current.code,
      );
      let freeCourses = await getCoursesWithAllFields(
        this.$app.config.current.code,
        this.giftBasketItemsIds,
      );
      freeCourses.map((item) => (item.free = true));
      this.giftBasketItems = [...freeCourses];
    },
    '$store.state.sale.basketDialog'(value) {
      if (this.basketType === 3 && !value) {
        this.clearBasketIgnoringLocalStorage();
      }
    },
  },
  mounted() {
    this.$nextTick().then(
      this.$nextTick(() => {
        if (this.$refs.salePanelTop && this.$refs.salePanelBottom) {
          this.salePanelTop = this.$refs.salePanelTop;
          this.salePanelBottom = this.$refs.salePanelBottom;
          this.changePannelsOpacity();
          document.addEventListener('scroll', this.changePannelsOpacity);
          window.addEventListener('resize', this.changePannelsOpacity);
        }
      }),
    );
    if (process.client) {
      this.requestCompanyCatalog = this.getCompanyCatalogLocalStorage();
    }
  },
  unmounted() {
    document.removeEventListener('scroll', this.changePannelsOpacity);
    window.removeEventListener('resize', this.changePannelsOpacity);
  },
  async created() {
    if (process.browser) {
      this.$gtm?.push({ source_id: this.$app.config.current.sourceId.sale });
    }
  },
  beforeDestroy() {
    this.$store.commit('sale/setSale', null);
  },
  methods: {
    changePannelsOpacity() {
      let salePanelBottomOffsetTop =
        this.salePanelBottom?.$el?.getBoundingClientRect().y;

      this.currentWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      if (
        salePanelBottomOffsetTop <= 20 &&
        this.currentWidth >= this.mobileBreakpoint
      ) {
        this.salePanelTop.$el.style.opacity = 1;
        this.salePanelTop.$el.style.display = 'flex';
        this.salePanelBottom.$el.style.opacity = 0;
      } else {
        this.salePanelTop.$el.style.opacity = 0;
        this.salePanelTop.$el.style.display = 'none';
        this.salePanelBottom.$el.style.opacity = 1;
      }
    },
    addToBasket({ item }) {
      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_addtocart',
        eventAction: 'offer',
        eventLabel: item.shortName || item.name,
      });

      this.basket.push(item);

      switch (this.basketType) {
        case 1:
          this.setProductInLocalStorage(item);
          break;
        case 2:
          this.setProductInLocalStorage(item);
          this.$store.commit('sale/setIsDisplayDetailProductDialog', false);
          this.openBasketModal();
          break;
        case 3:
          this.$store.commit('sale/setIsDisplayDetailProductDialog', false);
          this.openBasketModal();
          break;
      }
    },
    openBasketModal() {
      this.debug({ name: 'openBasketDialog' });

      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_click',
        eventAction: 'to_checkout',
      });

      this.$store.commit('sale/setBasketDialog', true);
    },
    removeFromBasket({ item }) {
      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_deletefromcart',
        eventAction: 'order',
        eventLabel: item.shortName || item.name,
      });

      this.basket = this.basket.filter(
        (basketItem) => item.id !== basketItem.id,
      );

      this.removeProductFromLocalStorage(item);
    },
    removeFromBasketEventHandler(product) {
      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'ds_deletefromcart',
        eventAction: 'order',
        eventLabel: product.shortName || product.name,
      });

      this.removeProductFromLocalStorage(product);
    },
    async clearFreeCourses() {
      this.promocodeItems = [];
    },
    async checkFreeCourses(value) {
      let basketItemsIds = this.basket.reduce(
        (acc, cur) => [...acc, cur.id],
        [],
      );
      let allIds = [
        ...new Set([...this.giftBasketItemsIds, ...basketItemsIds]),
      ];
      this.promocodeItemsIds = [...new Set(differenceBy(value, allIds))];
      let courses = await getCoursesWithAllFields(
        this.$app.config.current.code,
        this.promocodeItemsIds,
      );
      let newData = courses.map((item) => ({
        ...item,
        free: true,
      }));
      this.promocodeItems = [...newData];
    },
    clearBasket() {
      this.basket = [];

      localStorage.removeItem(`sale-${this.$store.state.sale.sale.id}`);
    },
    async sendCompanyCatalogRequest(payload) {
      const product = payload.item;

      try {
        this.setCompanyCatalogInLocalStorage(product);
        const data = JSON.stringify({
          userName: this.$app.user?.name,
          courseId: `id: ${product.id}, name: ${product.name}`,
          userId: this.$app.user?.id,
          companyName: this.$store.state.sale.sale.name,
          expirationDate: this.$store.state.sale.sale.endDate,
          country: this.$app.config.common.currentCountry,
        });
        this.requestCompanyCatalog = this.getCompanyCatalogLocalStorage();
        await this.$axios({
          method: 'POST',
          url: 'https://5hq4arldnl.execute-api.sa-east-1.amazonaws.com/Prod/create-jira-issue',
          data,
        });
      } catch (e) {
        handleError.bind(this)(e);
      }
    },
    getCompanyCatalogLocalStorage() {
      const catalogString = localStorage.getItem(
        `requestCompanyCatalog-${this.$store.state.sale.sale.id}`,
      );
      let companyCatalog = [];
      try {
        companyCatalog = JSON.parse(catalogString) || [];
      } catch (e) {
        console.error(e);
      }

      return companyCatalog;
    },
    setCompanyCatalogInLocalStorage(product) {
      const companyCatalogLocalStorage = this.getCompanyCatalogLocalStorage();
      if (!companyCatalogLocalStorage.includes(product.id)) {
        companyCatalogLocalStorage.push(product.id);

        localStorage.setItem(
          `requestCompanyCatalog-${this.$store.state.sale.sale.id}`,
          JSON.stringify(companyCatalogLocalStorage),
        );
        this.requestCompanyCatalog = companyCatalogLocalStorage;
      }
    },
  },
};
